import store from '@/store'

export function getSystemRole() {
  const userInfo = store.getters.userInfo
  if (!userInfo) return 'user'

  const roles = userInfo.roles || []
  const role = userInfo.role

  if (roles.includes('super_admin') || role === 'super_admin') return 'super_admin'
  if (roles.includes('admin') || role === 'admin') return 'admin'
  return 'user'
}

export function isSuperAdmin() {
  return getSystemRole() === 'super_admin'
}

export function isAdminOrAbove() {
  const role = getSystemRole()
  return role === 'super_admin' || role === 'admin'
}

export function filterCompaniesByPermission(companies, platform) {
  const role = getSystemRole()
  if (role === 'super_admin' || role === 'admin') return companies

  const userInfo = store.getters.userInfo
  const dataPerm = userInfo?.dataPermission || {}
  const allowedIds = dataPerm[platform] || []

  if (!allowedIds.length) return []

  return companies.filter(c => {
    const id = c.companyID || c.companyId || c.id
    return allowedIds.includes(String(id))
  })
}
